export enum ModuleAccessStatus {
    Trialing,
    Active,
    FreeAccess,
    NoAccess
}